import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

import { useSession } from './session-context.js';

/**
 * Route guard for the authenticated Console.
 *
 * This is navigation, not security. It stops a signed-out visitor being shown
 * an empty shell; it does not protect data. Every API call behind these routes
 * is authorised server-side regardless of what the router allows (§4.2).
 */
export function RequireAuth({ children }: { children: ReactNode }): React.JSX.Element {
  const { status } = useSession();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div role="status" aria-live="polite" style={{ padding: 'var(--s-6)' }}>
        Loading your workspace…
      </div>
    );
  }

  if (status === 'anonymous') {
    // Remember where they were headed so sign-in can return them there.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
